import React from 'react'
import { OverContainerSection, Content, Section } from './styles'
import { TypographyContent, TypographySection } from '../styles'
import { useTranslation } from 'react-i18next'

export const InitialSection = () => {
    const { t } = useTranslation()
    return (
        <OverContainerSection>
            <Section marginBottom={['medium', 'medium', 'large', 'titlle']}>
                <TypographySection
                    variant={'h1'}
                    fontSize={['xxxmedium', 'xxxmedium', 'large', 'xxsuper']}
                    fontWeight={700}
                >
                    {t('worldWile.sectionTitle')}
                </TypographySection>
                <Content marginTop={'xlarge'}>
                    <TypographyContent
                        variant={'h1'}
                        fontSize={['xxxsmall', 'xxxsmall', 'medium', 'xmedium']}
                        fontWeight={500}
                    >
                        {t('worldWile.sectionDescription')}
                    </TypographyContent>
                </Content>
            </Section>
        </OverContainerSection>
    )
}
